import styled from 'styled-components';
import { rem } from 'polished';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

export const CellContainer = styled(Box)<{ $isLease?: boolean }>`
    && {
        display: flex;
        padding: ${rem(4)} ${rem(6)};
        flex-direction: column;
        align-items: flex-start;
        /* Lease shows profit (no affordability), so its stack is 2 rows (no profit) or 3 (with profit);
           center it vertically either way. Finance keeps its fixed 3-row top-aligned layout. */
        justify-content: ${({ $isLease }) => ($isLease ? 'center' : 'flex-start')};
        gap: ${rem(2)};
        align-self: stretch;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
`;

export const TopGroup = styled(Box)`
    && {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: ${rem(2)};
        align-self: stretch;
    }
`;

export const TopRow = styled(Box)`
    && {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: ${rem(8)};
        width: 100%;
    }
`;

export const BottomRow = styled(Box)<{ $isLease?: boolean }>`
    && {
        display: flex;
        padding-top: ${rem(4)};
        justify-content: space-between;
        align-items: center;
        /* Finance lets the bottom row grow to fill (3-row cell); lease keeps it intrinsic so the
           centered group (2 rows without profit, 3 with) stays tight. */
        flex: ${({ $isLease }) => ($isLease ? '0 0 auto' : '1 0 0')};
        width: 100%;
        border-top: ${rem(1)} solid ${({ theme }) => theme.tokens.ColorNeutral50};
    }
`;

export const ProfitBadge = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.ColorOnSurfaceSuccessDefault};
        text-align: center;
        font-size: ${rem(10)};
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        white-space: nowrap;
    }
`;

export const AffordabilityText = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.ColorOnSurfaceMuted};
        text-align: center;
        font-size: ${rem(10)};
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        white-space: nowrap;
    }
`;

export const MonthlyPaymentText = styled(Typography)`
    && {
        grid-column: 1 / -1;
        font-size: ${rem(20)};
        font-weight: 700;
        text-align: center;
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceDefault};
    }
`;

export const LenderText = styled(Typography)`
    && {
        font-size: ${rem(11)};
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
    }
`;

export const RateText = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.ColorOnSurfaceMuted};
        font-size: ${rem(10)};
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
        text-align: right;
        border-radius: ${rem(4)};
        background: ${({ theme }) => theme.tokens.ColorSurfaceSubdued};
        padding: ${rem(2)} ${rem(4)};
    }
`;
